<header class="modal-header confirmar-correo-bg">
  <figure class="modal-title text-center w-100 p-5">
    <img class="ml-3" src="../../../../../assets/icons/correo_confirmacion.png" width="100" />
  </figure>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span class="text-white" aria-hidden="true">&times;</span>
  </button>
</header>
<section class="modal-body text-center pl-5 pr-5 pb-5">
  <label class="h5 text-body"><strong>¡Enviado!</strong></label>
  <p class="text-muted">{{mensaje}}</p>
  <button class="btn btn-primary" (click)="confirm()">Aceptar</button>
</section>
